/** @module store/energy_management_systems */

import * as actions from '@/store/modules/energy_management_systems/actions'
import * as getters from '@/store/modules/energy_management_systems/getters'
import * as mutations from '@/store/modules/energy_management_systems/mutations'

/**
 * Store state for current `energy_management_systems`.
 *
 * - {object} Ems or EnergyManagementSystem, defined by at least an `{integer} id` and a `{string} name`
 *
 * state.emss[emsId] => {object} includes all the EMS information for the EMS with the ID emsId, e.g name
 *
 * state.emsGroups[emsGroupId] => Array[Integer] includes the emsIds that are related to the EmsGroup with the ID emsGroupId
 *
 * state.users[userId] => Array[Integer] includes the emsIds that are related to the User with the ID userId
 *
 * @function
 *
 * @return {object}
 */

const state = () => ({
  emss: {},
  emsGroups: {},
  users: {}
})

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

/**
 * A Energy Management System (EMS) data-struct.
 *
 * Note: might be extended later.
 *
 * @constructor
 *
 * @param {object} params
 * @param {string|integer} params.id is the EMS's ID
 * @param {string} params.name is the EMS's name
 *
 */
export function Ems({ id, name, serialno = null, tz = null }) {
  if (!name) {
    throw TypeError(`Missing or invalid name ${name}.`)
  }

  this.id = parseInt(id)
  this.name = name
  this.serialno = serialno

  if (tz) {
    this.tz = tz
  }
}
